import React from "react";
import "./CollectionStorePicker.scss"
import close from "../../../assets/close.svg"
import collectionIC from "../../../assets/shop.svg"
import star from "../../../assets/star.svg"
import time from "../../../assets/clock-filled.svg"
import loc from "../../../assets/location-pin2.svg"


import { useDispatch, useSelector } from "react-redux";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../RestaurantWidget/utilities/helper/helper";
import { setOrderData, setSelectedOrderType } from "../../../../../../../../redux/resturantWidgetSlice";
import { updateOrderTypeDetails } from "../../../../RestaurantWidget/utilities/api/restaurantsService";
import moment from "moment";



const CollectionStorePicker = ({ isOpen, setIsOpen }) => {
    const { companies } = useSelector((state) => state.companyData);
    const toggleDrawer = () => setIsOpen(!isOpen);
    const dispatch = useDispatch()
    const storeClosed = useSelector((state) => state.companyData.storeClosed);

    const isNowWithinOpenHours = (company) => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        const nowMinutes = now.getHours() * 60 + now.getMinutes();

        const todaySchedule = company?.OpeningHour.find(day => day.Day === currentDay);

        if (!todaySchedule || todaySchedule.Closed || !todaySchedule.OpenHours.length) {
            return false;
        }

        for (const range of todaySchedule.OpenHours) {
            const [startH, startM] = range.StartTime.split(':').map(Number);
            const [endH, endM] = range.EndTime.split(':').map(Number);

            const startMinutes = startH * 60 + startM;
            const endMinutes = endH * 60 + endM;

            if (startMinutes <= endMinutes) {
                if (nowMinutes >= startMinutes && nowMinutes <= endMinutes) {
                    return range;
                }
            } else {
                if (nowMinutes >= startMinutes || nowMinutes <= endMinutes) {
                    return range;
                }
            }
        }

        return null;
    }
    const updateOrderType = (type) => {
        let orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ?? ""
        if (orderID !== "") {
            let body = {
                "OrderID": orderID,
                "DeliveryType": type,
                "CountryCode": "GB"
            }
            updateOrderTypeDetails(body).then((res) => {
                dispatch(setOrderData(res))
            })
        }

    }
    return (
        <div className="CollectionStorePicker">

            {isOpen && <div className="drawer-overlay" onClick={toggleDrawer} />}

            <div className={`CollectionStorePicker-drawer ${isOpen ? 'open' : ''}`}>
                <div className="drawer-header">
                    <img alt='' src={close} className="close-button" onClick={toggleDrawer} />
                    <img alt='' src={collectionIC} className="type-icon " />
                    <div className='right-drawer-header'>Select Collection Store</div>
                </div>
                <div className="drawer-content-container">
                    {companies.map((company, key) => {
                        return (
                            <div className="company-content-inner" key={key}>
                                <img alt="" className="company-image "
                                    src={company?.StoreImage ? company?.StoreImage : "https://img.freepik.com/premium-vector/storefront-line-design-hand-drawn-shop-line-art-vector-illustration_898083-3142.jpg?semt=ais_hybrid&w=740"} />
                                <div className="company-cont">
                                    <div className="comapny-title-con">
                                        <div className="comapny-title" >{company.Name}</div>
                                        {isNowWithinOpenHours(company) ? <div className="today-open">Open</div> : <div className="today-closed">Closed</div>}

                                    </div>
                                    <div className="content-text">
                                        <img alt="" src={loc} className="icon-loc" />{company.AddressLine1}, {company.City}, {company.PostZipCode}, {company.StateProvinceRegion}
                                    </div>
                                    <div className="content-text">
                                        <img alt="" src={time} className="icon-time" />Collection Time: 10-15 mins
                                    </div>
                                    <div className="content-text">
                                        <img alt="" src={star} className="icon-st" />4.8(2,453 reviews)
                                    </div>

                                    <div className="time-header-cont">Collection Time</div>
                                    <div className="opening-hours-text-co">
                                        {company?.OpeningHour?.map((open, key) => {
                                            return (
                                                <div key={key} className="opening-hours-text-val">
                                                    <div>{window.screen.width < 600 ? moment().day(open.Day).format("ddd") : open.Day}</div><div>{open?.Closed ? "Closed" : open.OpenHours?.map((date) => {
                                                        return (
                                                            <div>{date.StartTime + " - " + date.EndTime}</div>
                                                        )
                                                    })}</div>
                                                </div>)
                                        })}
                                    </div>
                                    {storeClosed["collection"] && <div className="current-status-cont">
                                        <div className="current-status-cont-header-cont">
                                            <img alt="" src={time} className="header-cont-icon" />
                                            <div className="header-cont-title ">Current Status</div>
                                        </div>
                                        <div className="current-status-cont-sub">
                                            Sorry, We're currently closed for collection.   </div>
                                    </div>}
                                    <div className="select-st-btn"
                                        onClick={() => {
                                            updateOrderType("TAKE_AWAY")
                                            localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_STR_LOC_ID, company.LocationID)
                                            dispatch(setSelectedOrderType("collection"))
                                            localStorage.removeItem("schedule_order")
                                            toggleDrawer()
                                        }}>
                                        Select This Store
                                    </div>
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
            </div>
        </div>
    )
}
export default CollectionStorePicker